// extracted by mini-css-extract-plugin
module.exports = {"container":"_2JbLEUi35TcRrmWwE-DtP_","groupsList":"k5wzzkU0ZaFKuzxFTeF2L"};